import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

const DetalleOpeNivel1 = props => {
  return (
    <option dato1={props.elemento.cedula} 
    dato2={props.elemento.ciudad?props.elemento.ciudad:""} 
    dato3={props.elemento.email?props.elemento.email:""} 
    dato4={props.elemento.telefono?props.elemento.telefono:""} 
    value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  ) 
};

const ListaCom = ({list, handleLista}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleOpeNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="comercialAtiende" id="miLista" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel4Detalle}
      </select>
    </div>
  )
};

const ListaPais = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="pais" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Colombia</option>
        <option>Panamá</option>
      </select>
    </div>
  )
};

// const AddEmpresa2 = ({this.props.styles, handleSubmit, handleChange, args, errors}) => {
  class AddEmpresa2 extends React.Component{
    state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    let file = "", logo = ""
    if(ev.target.files[0]){
      file = ev.target.files[0]
      logo = ev.target.files[0].name
    }
    argsAdd['logo'] = logo
    argsAdd['file'] = file
    this.setState({argsAdd})
  }
  
  render(){
  const {argsAdd} = this.state;
  let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
  let args = Object.assign({}, this.props.args, argsAdd)

  let listRes = []
  if(this.props.allUsuariosRtesCom.allUsuariosRtes){
    this.props.allUsuariosRtesCom.refetch()
    listRes = this.props.allUsuariosRtesCom.allUsuariosRtes
  }

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Empresa nueva
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <div className="column" width="100%">                
                  <Form.Field>
                    <label style={this.props.styles.label}>Pais</label>
                    <ListaPais styles={this.props.styles} handleLista={this.props.handleLista1} />
                  </Form.Field>     
                </div>
                <Form.Field>
                  <div className="column" style={{width: '100%'}}>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrEmpresa" id="descrEmpresa" onChange={this.props.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrEmpresa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </div>
                </Form.Field>
                <Form.Field>
                  <div className="column" style={{width: '100%'}}>
                    <label style={this.props.styles.label}>Nit</label>
                    <Form.Input autoComplete="off" name="nit" id="nit" onChange={this.props.handleChange} placeholder='NIT' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nit'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </div>
                </Form.Field>
                <Form.Field>
                  <div className="column" style={{width: '5%'}}>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codEmpresa" id="codEmpresa" onChange={this.props.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codEmpresa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </div>
                </Form.Field>
                <div className="column" width="50%">                
                  <Form.Field>
                    <label style={this.props.styles.label}>Comercial que atiende</label>
                    <ListaCom list={listRes} handleLista={this.props.handleLista} />
                  </Form.Field>     
                </div>
                <Form.Field>
                  <label style={this.props.styles.label}>Dirección</label>
                  <Form.Input autoComplete="off" name="direccion" id="direccion" onChange={this.props.handleChange} placeholder='Dirección' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'direccion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                {/* <Form.Field>
                  <label style={this.props.styles.label}>Mail</label>
                  <Form.Input autoComplete="off" name="mail" id="mail" onChange={this.props.handleChange} placeholder='Mail' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'mail'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> */}
                <Form.Field>
                  <label style={this.props.styles.label}>Teléfono</label>
                  <Form.Input autoComplete="off" name="telefono" id="telefono" onChange={this.props.handleChange} placeholder='Teléfono' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>  
                <Form.Field>
                  <div className="column" style={{width: '50%'}}>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar logo...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" required accept="image/*" style={estilos} onChange={this.handleChange}></input>
                  </div>
                </Form.Field>  
                {/* <Form.Field>                  
                  <label style={this.props.styles.label}>Nombre de archivo del logo</label>
                  <Form.Input autoComplete="off" name="logo" id="logo" onChange={this.props.handleChange} placeholder='Nombre de archivo del logo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'logo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>   */}
                <Button style={this.props.styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddEmpresa2
export default compose(
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtesCom',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Comercial'}}]`}}}}),

  )(AddEmpresa2)